// Sections
import Hero from '/views/sections/home/hero';
import Features from '/views/sections/home/features';
import Solutions from '/views/sections/home/solutions';
import Pricing from '/views/sections/home/pricing';
// import Contact from '/views/sections/home/contact';
import FeaturedNumbers from '/views/sections/home/featured-numbers';
import References from '/views/sections/home/references';
import Spotlight from '/views/sections/spotlight';

// Static Assets
import image_spotlight_incypay from '/assets/images/spotlights/incypay.png';
import image_spotlight_incyticket from '/assets/images/spotlights/incyticket.png';
import image_spotlight_incyrestaurant from '/assets/images/spotlights/incyrestaurant.png';
import image_spotlight_incyscreen from '/assets/images/spotlights/incyscreen.png';

const Homepage = () => {	
	return (
		<main>
			<Hero />

			<FeaturedNumbers />

			<Features />

			<Spotlight
				id="incy-pay"
				icon="payment"
				title="Incy Pay"
				subtitle="Contactless payment infrastructure, wallet management, and credit card top-ups. A fast, secure payment experience at events and restaurants."
				mockup={image_spotlight_incypay}
				features={[
					{
						icon: 'contactless',
						text: <>Contactless Payment Infrastructure</>
					},
					{
						icon: 'wallet',
						text: <>Advanced Wallet Management</>
					}
				]} />

			<Spotlight
				darkBg
				id="incy-ticket"
				icon="ticket"
				title="Incy Ticket"
				subtitle="Online ticket sales, invitation management, and fast entry control systems. Ticketing solutions for assigned seating or general admission."
				imagePosition="left"
				mockup={image_spotlight_incyticket}
				features={[
					{
						icon: 'qr',
						text: <>Fast-Pass Control Systems</>
					},
					{
						icon: 'seat',
						text: <>Venue Support with Seating Plans</>
					}
				]} />

			<Spotlight
				id="incy-restaurant"
				icon="restaurant"
				title="Incy Restaurant"
				subtitle="Digital QR menu, online ordering, table and waiter management system. End-to-end restaurant solutions that increase operational efficiency."
				mockup={image_spotlight_incyrestaurant}
				features={[
					{
						icon: 'qr',
						text: <>Digital QR Menu System</>
					},
					{
						icon: 'table',
						text: <>Table & Service Management</>
					}
				]} />

			<Spotlight
				darkBg
				id="incy-screen"
				icon="tv"
				title="Incy Screen"
				subtitle="Centralized management of all physical screens. Real-time planning and broadcasting of video, visual, and campaign content."
				imagePosition="left"
				mockup={image_spotlight_incyscreen}
				features={[
					{
						icon: 'remote',
						text: <>Central Screen Management</>
					},
					{
						icon: 'sync',
						text: <>Instant Updates</>
					}
				]} />

			<Solutions />

			<Pricing />

			{/* <Contact /> */}

			<References />
		</main>
	)
}

export default Homepage
